export function isObject(o: unknown): o is object {
  return typeof o === 'object' && o !== null;
}

export const pick = <T extends Record<string, unknown>, K extends (keyof T)[]>(obj: T, keys: K): Pick<T, K[number]> => {
  if (!obj || !isObject(obj)) return obj;

  return keys.reduce((prev, cur) => {
    prev[cur] = obj[cur];
    return prev;
  }, {} as Pick<T, K[number]>);
};
